import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/Home'
import Test from '@/components/Test'
import User from '@/components/User'
import FAQ from '@/components/FAQ'
import DataDownload from '@/components/DataDownload'
import Submit from '@/components/Submit'
import MoreInfo from '@/components/MoreInfo'
import Task from '@/components/Task'
import Leaderboard from '@/components/Leaderboard'
import Report from '@/components/Report'
import AboutUs from '@/components/AboutUs'
import TaskBoard from '@/components/TaskBoard'
import Admin from '@/components/Admin'
import Reset from '@/components/Reset'
import Dataset from '@/components/Dataset'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: {
        title: 'CUGE'
      },
      component: Home
    },
    {
      path: '/User',
      meta: {
        title: 'CUGE'
      },
      name: 'User',
      component: User
    },
    {
      path: '/faq',
      meta: {
        title: 'CUGE'
      },
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/test',
      meta: {
        title: 'CUGE'
      },
      name: 'Test',
      component: Test
    },
    {
      path: '/download',
      meta: {
        title: 'CUGE'
      },
      name: 'DataDownload',
      component: DataDownload
    },
    {
      path: '/submit',
      meta: {
        title: 'CUGE'
      },
      name: 'Submit',
      component: Submit
    },
    {
      path: '/more',
      meta: {
        title: 'CUGE'
      },
      name: 'MoreInfo',
      component: MoreInfo
    },
    {
      path: '/task',
      meta: {
        title: 'CUGE'
      },
      name: 'Task',
      component: Task
    },
    {
      path: '/leaderboard',
      meta: {
        title: 'CUGE'
      },
      name: 'Leaderboard',
      component: Leaderboard
    },
    {
      path: '/report',
      meta: {
        title: 'CUGE'
      },
      name: 'Report',
      component: Report
    },
    {
      path: '/about',
      meta: {
        title: 'CUGE'
      },
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/taskboard',
      meta: {
        title: 'CUGE'
      },
      name: 'TaskBoard',
      component: TaskBoard
    },
    {
      path: '/admin',
      meta: {
        title: 'CUGE'
      },
      name: 'Admin',
      component: Admin
    },
    {
      path: '/reset',
      meta: {
        title: 'CUGE'
      },
      name: 'Reset',
      component: Reset
    },
    {
      path: '/dataset',
      meta: {
        title: 'CUGE'
      },
      name: 'Dataset',
      component: Dataset
    },
    {
      path: '/ccl/2024/crmus',
      meta: {
        title: 'CRMUS'
      },
      name: 'crmus',
      component: () => import("@/components/ccl/2024/crmus")
    },
    {
      path: '/ccl/2023/gcrc',
      meta: {
        title: 'GCRC'
      },
      name: 'gcrc',
      component: () => import("@/components/ccl/2023/gcrc")
    },
    {
      path: '/ccl/2023/cltc',
      meta: {
        title: 'CLTC'
      },
      name: 'CLTC',
      component: () => import("@/components/ccl/2023/cltc")
    },
    {
      path: '/ccl/2022/celue',
      meta: {
        title: 'CELUE'
      },
      name: 'celue',
      component: () => import("@/components/ccl/2022/elue")
    },
    {
      path: '/ccl/2022/yaclc',
      meta: {
        title: 'YACLC'
      },
      name: 'yaclc',
      component: () => import("@/components/ccl/2022/yaclc")
    },
    {
      path: '/ccl/center',
      meta: {
        title: 'CENTER'
      },
      name: 'center',
      component: () => import("@/components/ccl/ccl_center")
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js